import React, { useEffect, useState } from 'react';
import { TitleStyle } from '../RoadSearchersTaskList/StyledComponents';
import axios from 'axios';
import { TaskRow } from './TaskRow';
import { ChartGrid, ChartWrapper, ComputerWrapper } from './styled';
import { InPersonMunicipalityQueueTask } from './types';

export const NjInPersonMunicipalityQueue = () => {
  const [reportData, setReportData] = useState<InPersonMunicipalityQueueTask[]>([]);

  useEffect(() => {
    getReport();
  }, []);

  const getReport = async () => {
    const { data } = await axios.get(`/api/reports/getNjInPersonMunicipalityQueue`);
    setReportData(data);
  };
  return (
    <React.Fragment>
      <ComputerWrapper>
        <TitleStyle>NJ In Person Municipality Queue</TitleStyle>
        <ChartWrapper>
          <ChartGrid>
            <div></div>
            <div>HDS</div>
            <div>Town</div>
            <div>Property</div>
            <div>BLQ</div>
            <div>Date Added</div>
          </ChartGrid>
          {reportData.map(r => {
            return <TaskRow key={r.id} reportData={r} />;
          })}
        </ChartWrapper>
      </ComputerWrapper>
    </React.Fragment>
  );
};
